import { render, staticRenderFns } from "./addressDialog.vue?vue&type=template&id=486751d6"
import script from "./addressDialog.vue?vue&type=script&lang=js"
export * from "./addressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports